import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AgreeToUpdate extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'You Agree to Update this Information Whenever It Changes or Requested?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
    requiredToContinue: true,
    errorRequiredMessage: 'To Proceed You Must Confirm!',
  };
}
